export enum Launch_Relax_Hacksaw {
  "PT-BR" = "PT-BR",
  "ES" = "ES",
  "HU" = "HU",
}
